import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { SecurityGroup } from '@admin/models/system-configuration-model';

@Injectable({ providedIn: 'root' })
export class SecurityGroupsHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilderService: UrlBuilderService) { }

  getSecurityGroups(): Observable<SecurityGroup[]> {
    const url = this.urlBuilderService.getMojoApiUrl(`eas/getsecuritygroups`);
    return this.http.get<SecurityGroup[]>(url);
  }
}
